import { Text as ReactText } from "@certn/cascadia-react/foundations/typography/Text";
import { ElementType, memo } from "react";

import { CascadiaTextProps } from "./types";

type WebTextProps = CascadiaTextProps & {
  as?: ElementType;
};

export const Text = memo(function (props: WebTextProps) {
  return <ReactText {...props} />;
});
